<template>
  <PieChart
    :request-status="requestStatus"
    :series="series"
    :title="title"
    :item-id="itemId"
    class="make-a-copy"
    v-bind="$attrs"
    @reload="getData"
  />
</template>

<script>
import PieChart from '@/components/cards/models/PieChart';
import channelModel from '@/mixins/channel-model';
import { mapActions } from 'vuex';
import EventBus from '@/utils/event-bus';
import { POST_FIELDS, OPERATION, DATE_PORTION } from '@/services/charts-service';

export default {
  name: 'BaseChannelPieChart',
  components: {
    PieChart,
  },
  mixins: [
    channelModel,
  ],
  props: {
    title: {
      type: String,
      required: true,
    },
    itemId: {
      type: [String, Number],
      required: true,
    },
    operation: {
      type: String,
      default: OPERATION.COUNT,
    },
  },
  data() {
    return {
      requestStatus: 'loading',
      rawSeries: [],
    };
  },
  computed: {
    series() {
      const _rawSeries = Array.from(this.rawSeries)
        .filter(rawSerie => {
          return 'name' in rawSerie;
        });
      return _rawSeries.map(({ name, data }) => {
        const channelObj = this.getChannelColorNameAndIcon(name);
        return {
          name: channelObj.name,
          color: channelObj.color,
          y: data[0],
        };
      });
    },
  },
  created() {
    this.getData();
  },
  methods: {
    ...mapActions('cards', [
      'getChartsService',
    ]),
    getData(options) {
      if (!options?.silentRefresh) {
        this.requestStatus = 'loading';
      }

      this.getChartsService({
        itemId: this.itemId,
        method: 'getTimeSeries',
        params: {
          datePortion: DATE_PORTION.BY_YEAR,
          grouping: [POST_FIELDS.CHANNEL],
          operators: this.operation,
        },
      })
        .then(response => {
          this.rawSeries = response.points.sort((a, b) => {
            return a.data[0] > b.data[0]
              ? -1 : a.data[0] < b.data[0]
                ? 1 : 0;
          });
          this.requestStatus = 'success';

          if (options?.silentRefresh) {
            EventBus.$emit('updated', { itemId: this.itemId });
          }
        })
        .catch(error => {
          console.error(error);
          this.requestStatus = 'error';
        });
    },
  },
};
</script>
